import { render, staticRenderFns } from "./Corruption.vue?vue&type=template&id=15c72fe5"
import script from "./Corruption.vue?vue&type=script&lang=js"
export * from "./Corruption.vue?vue&type=script&lang=js"
import style0 from "./Corruption.vue?vue&type=style&index=0&id=15c72fe5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports